export const CORE_FINTECH_UI_NAME = "core-fintech-ui";

export enum CoreFintechUiComponents {
  WebComponentLoader = "WebComponentLoader",
  HtsIFrameLoader = "HtsIFrameLoader",
  HtsCfarExerciseWrapper = "HtsCfarExerciseWrapper",
  HtsExerciseSuccessConfirmation = "HtsExerciseSuccessConfirmation",
  FintechProduct = "FintechProduct",
  FintechProductBullet = "FintechProductBullet",
  FintechProductOptionsSection = "FintechProductOptionsSection",
  FintechProductInfoLinksSection = "FintechProductInfoLinksSection",
  FintechMarketplaceSection = "FintechMarketplaceSection",
  FintechMarketplacePage = "FintechMarketplacePage",
  FintechMarketplaceProductBreadcrumbList = "FintechMarketplaceProductBreadcrumbList",
  FintechMarketplaceProductBreadcrumbItem = "FintechMarketplaceProductBreadcrumbItem",
}
